import PropTypes from 'prop-types';
import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import Typography from 'Components/UI/Typography';
import classNames from 'classnames';
import JoinMeetingButton from 'Components/UI/JoinMeetingButton';
import { getFormattedDateWithTimezone } from 'Helpers/DateTime';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const RIGHT_COLUMN_WIDTH = 330;

const useStyles = buildUseStyles('MeetingHeader', (theme) => ({
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  mobileHeaderText: {
    marginBottom: theme.spacing(1),
  },
  zoomButton: {
    maxWidth: RIGHT_COLUMN_WIDTH,
    marginRight: theme.spacing(1),
  },
}));

const MESSAGE_TYPE_AGENDA = 'agenda';
const MESSAGE_TYPE_FOLLOW_UP = 'follow-up';
const MESSAGE_TYPE_OTHER = 'other';

const MeetingCommunicationHeader = ({
  meetingAgenda,
  meetingResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();

  let meetingLabel = '';
  let showJoinMeetingButton = false;
  switch (meetingAgenda?.attr('messageType')) {
    case MESSAGE_TYPE_AGENDA:
      if (meetingResource) {
        meetingLabel = `Agenda for ${getFormattedDateWithTimezone(meetingResource?.attr('startTime'))}`;
      }
      showJoinMeetingButton = true;
      break;
    case MESSAGE_TYPE_FOLLOW_UP:
      if (meetingResource) {
        meetingLabel = `Follow-up for meeting on ${getFormattedDateWithTimezone(meetingResource?.attr('startTime'))}`;
      }
      break;
    case MESSAGE_TYPE_OTHER:
    default:
    // No meeting label to set
  }

  return (
    <div
      className={classes.header}
    >
      <Typography
        variant="h5"
        color="blueMuted"
        className={classNames({
          [classes.mobileHeaderText]: isMobile,
        })}
      >
        {meetingLabel}
      </Typography>
      {showJoinMeetingButton && meetingResource && (
        <JoinMeetingButton
          className={classes.zoomButton}
          meetingResource={meetingResource}
        />
      )}
    </div>
  );
};

MeetingCommunicationHeader.propTypes = {
  meetingAgenda: PropTypes.object.isRequired,
  meetingResource: PropTypes.object.isRequired,
};

export default MeetingCommunicationHeader;
